import React, { useEffect, useRef } from 'react';

import TriangleIcon from 'images/crypto_powerlist/Triangle.png';
import XIcon from 'images/crypto_powerlist/X.png';

const DetailsRow = ({ details, handleClose, isOperatorsSection }) => {
  const detailsRowRef = useRef(null);
  const imgixUrl = 'https://tii.imgix.net/production/crypto-power-list/dropdown';

  useEffect(() => {
    if (detailsRowRef.current) {
      detailsRowRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [details]);

  return (
    <div className="details-row mb3" ref={detailsRowRef}>
      <div className="rank">{details.rank}</div>
      <div className="details-portrait-container">
        <div className="details-name">{details.name}</div>
        <div className="details-image">
          <img
            height={250}
            width={250}
            src={`${imgixUrl}/${details.photo}?fmt=webp&w=250&h=250&fit=crop`}
          />
          <div className="details-source">{details.source}</div>
        </div>
      </div>
      {isOperatorsSection || details.type === 'operator' ? (
        <div className="description-container">
          <div className="overview">
            <div>Company</div>
            <div>{details.firm}</div>
          </div>
          <div className="overview">
            <div>Valuation</div>
            <div>{details.value}</div>
          </div>
          <div className="overview">
            <div>Extra Credit</div>
            <div>{details.extra_info}</div>
          </div>
          <div className="description-text">{details.description}</div>
          {details.notes && <div className="note-text">{details.notes}</div>}
        </div>
      ) : (
        <div className="description-container">
          <div className="overview">
            <div>Firm</div>
            <div>{details.firm}</div>
          </div>
          <div className="overview">
            <div>Key Investments</div>
            <div>{details.extra_info}</div>
          </div>
          <div className="overview">
            <div>Most Recent Fund</div>
            <div>{details.value}</div>
          </div>
          <div className="description-text">{details.description}</div>
          {details.notes && <div className="note-text">{details.notes}</div>}
        </div>
      )}
      <img className="triangle" src={TriangleIcon} alt="triangle" />
      <input
        className="close-button"
        onClick={handleClose}
        type="image"
        name="closeButton"
        src={XIcon}
        alt="x"
      />
    </div>
  );
};

export default DetailsRow;
